// src/utils/realm.js
//
// Realm detection for the Partner Portal.
//
// Intelligence Navigator (app.xpherium.com) and the Partner Portal
// (partner.xpherium.com) are served from the SAME single-page app build but
// on DIFFERENT origins. Because browsers scope localStorage/sessionStorage
// per-origin, the partner subdomain automatically gets its own isolated auth
// token store — a user can be signed into IN in one tab and the Partner
// Portal (even as a different identity) in another, with neither session
// affecting the other. No shared-key juggling required.
//
// This module centralizes "are we on the partner origin?" and "what URL do I
// open to reach the partner origin?" so the rest of the app stays simple.

const PARTNER_HOSTNAME = 'partner.xpherium.com';

/** True when the current page is being served from the partner subdomain. */
export function isPartnerHost() {
  try {
    return /^partner\./i.test(window.location.hostname || '');
  } catch {
    return false;
  }
}

/**
 * Absolute URL used to open the Partner Portal as its own isolated origin.
 * Appends the current locale when opening a different subdomain so the
 * partner portal inherits the language the user was using in IN.
 */
export function getPartnerPortalUrl(locale) {
  let path = '/partner-portal';
  try {
    const { hostname, protocol } = window.location;
    if (/(^|\.)xpherium\.com$/i.test(hostname)) {
      path = `${protocol}//${PARTNER_HOSTNAME}/partner-portal`;
    }
  } catch {
    /* noop */
  }
  if (!locale) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}lang=${encodeURIComponent(locale)}`;
}

/**
 * Absolute URL back to the Intelligence Navigator app origin, used by the
 * Partner Portal's "Back to Intelligence Navigator" affordance.
 */
export function getIntelligenceNavigatorUrl(path = '/dashboard') {
  const clean = path && path.startsWith('/') ? path : `/${path || ''}`;
  try {
    const { hostname, protocol } = window.location;
    if (/(^|\.)xpherium\.com$/i.test(hostname)) {
      return `${protocol}//app.xpherium.com${clean}`;
    }
  } catch {
    /* noop */
  }
  return clean;
}
